<template>
    <div class="w-full flex-1 flex flex-col p-2 lg:p-6 space-y-5 lg:pb-18">
        <nav class="flex-grow">
            <p class="truncate py-2.5 px-3 text-sm font-medium ct-text-2">{{ player.name }}</p>

            <NavbarPrimaryItem
                v-for="navItem in navigation"
                :key="navItem.label"
                :class="{ 'is-active': currentHeader.label === navItem.label }"
                @click="navItem.handler"
            >
                <component :is="navItem.icon" />
                <span>{{ navItem.label }}</span>
            </NavbarPrimaryItem>
        </nav>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { NavbarPrimaryItem } from "@easy/ui/navbars";

export default {
    name: "PlayerPanelSidebar",
    props: {
        navigation: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        NavbarPrimaryItem,
    },

    computed: {
        ...mapState("player", ["player"]),
        currentHeader() {
            return this.navigation.find((item) => item.name === this.$route.name);
        },
    },
};
</script>
